export default {
      id: "alert-exclamation-icon-encircled-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#alert-exclamation-icon-encircled",
      toString: function () {
        return this.url;
      }
    }